module.exports = __webpack_public_path__ + "img/a16f5ef.png";